var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listVideoAdverts)?_c('div',{staticClass:"videoBox"},[(_vm.listVideoAdverts.length > 0)?_c('div',{staticClass:"videoToolBox"},[_c('video-item',{attrs:{"videoUrl":_vm.listVideoAdverts[0].ImgUrl}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }